/** @module Specification/ResponseItemsTable */
define([
	"dojo/_base/declare",
	"csi/heading/String",
	"csi/store/Nodes",
	"csi/table/_GroupByRefMixin",
	"csi/table/Widget",
	"SpecificationDataSheet/Core/util"
], function(declare, StringRen, Nodes, _GroupByRefMixin, Widget, util) {

	var _GroupRenderer = declare(StringRen, {

		/**
		 * Render response section definition name in bold
		 * @override
		 */
		toHtmlStatic: function(ctx, h, refNode, actionData) {
			const {cache, queryResult} = ctx;
			const section = queryResult && !queryResult.bNewlyCreated && cache.getNode(queryResult.groupValue);
			if (section && (section.$Type == "ResponseSection")) {
				// render definition name in bold
				util.renderSectionDefinition(ctx, section, refNode);
			}

			return this.inherited(arguments);
		},

		/**
		 * Do not allow editing of group name
		 * @override
		 */
		_getAction: function() {
			return null;
		}
	});

	return declare([Widget, _GroupByRefMixin], {
		groupByRefAttr: "Section",
		groupRendererClass: _GroupRenderer,

		/**
		 * Always return true as it has no CV configuration on grouping and always grouped by section
		 * @override
		 */
		isGroupBySection: function(allowTwoGroups) {
			return true;
		},

		/**
		 * Configure query level for group
		 * @param {Level} ql
		 */
		onGroupByRefQueryLevel: function(ql) {
			const view = this.getViewNode();
			let sections = view && this.cacheView.getNodes(view.ResponseSections);
			if (view && view.$Type == "SpecificationDataSheetSupplierResponse") {
				const responseRevNode = this.cacheView.getNode(view.LatestRevision);
				sections = this.cacheView.getNodes(responseRevNode.ResponseSections);
			}

			let store = new Nodes({
				data: sections
			});

			ql.groupDefaultsStore = store;
		}
	});
});